import { CarouselItem } from '@/components/ui/carousel'
import { useTranslation } from 'react-i18next'

export default function IntroScreen() {
  const { t } = useTranslation()

  return (
    <CarouselItem className='px-2 sm:px-8'>
      <div className='space-y-3 py-2 text-center sm:space-y-6 sm:py-6'>
        <div className='space-y-2 sm:space-y-4'>
          <h3 className='text-lg font-semibold text-gray-900 sm:text-2xl'>{t('needsAnalysis.intro.title')}</h3>
          <p className='mx-auto max-w-xl text-sm text-gray-600 sm:text-lg'>{t('needsAnalysis.intro.description')}</p>
        </div>
        <div className='flex items-center justify-center gap-2 text-xs text-gray-500 sm:text-sm'>
          <span>{t('needsAnalysis.intro.duration')}</span>
          <span>•</span>
          <span>{t('needsAnalysis.intro.sections')}</span>
        </div>
      </div>
    </CarouselItem>
  )
}
